import type { LocaleMessageBundle } from '../../types'

export const productLocationMessages: LocaleMessageBundle = {
  vi: {
    'product.location.model': 'Vị trí',
    'product.location.title': 'Quản lý vị trí sản phẩm',
    'product.location.fields.code': 'Mã vị trí',
    'product.location.fields.name': 'Tên vị trí',
    'product.location.fields.path': 'Đường dẫn vị trí',
    'product.location.fields.parent': 'Vị trí cha',
    'product.location.fields.branch': 'Chi nhánh',
    'product.location.fields.default': 'Mặc định',
    'product.location.default.badge': 'Mặc định',
    'product.location.help.default': 'Hàng nhập sẽ tự động được phân bổ vào vị trí mặc định của chi nhánh.',
    'product.product.fields.locations': 'Vị trí lưu trữ',
    'product.product.hints.locations': 'Chọn các vị trí thường dùng cho sản phẩm tại chi nhánh.',
    'product.location.fields.description': 'Mô tả',
    'product.location.fields.sortOrder': 'Thứ tự',
    'product.location.fields.status': 'Trạng thái',
    'product.location.fields.type': 'Loại node',
    'product.location.fields.productsCount': 'Sản phẩm',
    'product.location.fields.inventoryCount': 'Dòng tồn',
    'product.location.types.parent': 'Phân nhóm',
    'product.location.types.leaf': 'Chứa tồn kho',
    'product.location.actions.create': 'Thêm vị trí',
    'product.location.actions.update': 'Cập nhật vị trí',
    'product.location.actions.addChild': 'Thêm vị trí con',
    'product.location.dialog.createSubtitle': 'Tạo node vị trí mới trong cây kho',
    'product.location.dialog.updateSubtitle': 'Cập nhật thông tin và vị trí cha của node',
    'product.location.parent.none': 'Không có — vị trí gốc',
    'product.location.help.parent': 'Node đang chứa sản phẩm hoặc tồn kho không thể có vị trí con.',
    'product.location.help.leafOnly': 'Chỉ node cấp thấp nhất mới được phép chứa tồn kho.',
    'product.location.deleteConfirm': 'Bạn có chắc muốn xóa vị trí {name}?',
    'product.location.errors.saveFailed': 'Không thể lưu vị trí. Vui lòng thử lại.',
    'product.location.validation.sortOrder': 'Thứ tự phải là số nguyên từ 0 đến 65535.',
  },
  en: {
    'product.location.model': 'Location',
    'product.location.title': 'Product locations',
    'product.location.fields.code': 'Location code',
    'product.location.fields.name': 'Location name',
    'product.location.fields.path': 'Location path',
    'product.location.fields.parent': 'Parent location',
    'product.location.fields.branch': 'Branch',
    'product.location.fields.default': 'Default',
    'product.location.default.badge': 'Default',
    'product.location.help.default': 'Received stock will be allocated to the branch default location automatically.',
    'product.product.fields.locations': 'Storage locations',
    'product.product.hints.locations': 'Select the usual storage locations for this product in the branch.',
    'product.location.fields.description': 'Description',
    'product.location.fields.sortOrder': 'Sort order',
    'product.location.fields.status': 'Status',
    'product.location.fields.type': 'Node type',
    'product.location.fields.productsCount': 'Products',
    'product.location.fields.inventoryCount': 'Stock rows',
    'product.location.types.parent': 'Grouping node',
    'product.location.types.leaf': 'Inventory location',
    'product.location.actions.create': 'Add location',
    'product.location.actions.update': 'Update location',
    'product.location.actions.addChild': 'Add child location',
    'product.location.dialog.createSubtitle': 'Create a new node in the storage tree',
    'product.location.dialog.updateSubtitle': 'Update the node and its parent location',
    'product.location.parent.none': 'None — root location',
    'product.location.help.parent': 'A node containing products or stock cannot have children.',
    'product.location.help.leafOnly': 'Only leaf nodes can contain inventory.',
    'product.location.deleteConfirm': 'Are you sure you want to delete location {name}?',
    'product.location.errors.saveFailed': 'Unable to save the location. Please try again.',
    'product.location.validation.sortOrder': 'Sort order must be an integer from 0 to 65535.',
  },
}
